var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1768 12.1777V5.79703C15.1765 5.5173 15.1026 5.24256 14.9626 5.00038C14.8226 4.75819 14.6214 4.55708 14.3792 4.41722L8.79611 1.22689C8.55362 1.08689 8.27854 1.01318 7.99853 1.01318C7.71853 1.01318 7.44345 1.08689 7.20095 1.22689L1.61789 4.41722C1.37564 4.55708 1.17442 4.75819 1.03443 5.00038C0.894442 5.24256 0.820599 5.5173 0.820312 5.79703V12.1777C0.820599 12.4574 0.894442 12.7321 1.03443 12.9743C1.17442 13.2165 1.37564 13.4176 1.61789 13.5575L7.20095 16.7478C7.44345 16.8878 7.71853 16.9615 7.99853 16.9615C8.27854 16.9615 8.55362 16.8878 8.79611 16.7478L14.3792 13.5575C14.6214 13.4176 14.8226 13.2165 14.9626 12.9743C15.1026 12.7321 15.1765 12.4574 15.1768 12.1777Z",
    stroke: "#0078FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03516 4.96777L7.99803 8.99555L14.9609 4.96777",
    stroke: "#0078FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.0264V8.98682",
    stroke: "#0078FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBox);
export default __webpack_public_path__ + "static/media/blue-box.903329a0a357e9ab0f96c4c2b7d36cab.svg";
export { ForwardRef as ReactComponent };